import {SmsFiltersState} from "@/store/sms/filters/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {actions} from "@/store/sms/filters/actions";
import {getters} from "@/store/sms/filters/getters";
import {mutations} from "@/store/sms/filters/mutations";

export const state: SmsFiltersState = {
  smsFilters: [],
}

export const smsFilter: Module<SmsFiltersState, RootState> = {
  state,
  getters,
  actions,
  mutations
}